/** @jsx jsx */
import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { jsx } from '@balance-web/core';

import { useClient } from '../components/hooks';
import { SignInComponent } from '../components/authentication/signIn/signIn';
import { Layout } from '../components/layout';
import { useNavigationWithQuery } from '../components/authentication/useNavigationWithQuery';
import { useRedirectToClient } from '../components/authentication/useRedirectToClient';

export default function Page() {
  const router = useRouter();

  const { tenancy: TENANCY, product } = useClient();

  const { navigateTo } = useNavigationWithQuery();
  const { redirectToClient } = useRedirectToClient();

  const [resetPasswordSuccess, setResetPasswordSuccess] = useState<boolean>(
    false
  );

  useEffect(() => {
    setResetPasswordSuccess(router?.query?.redirectedFrom === 'reset-password');
  }, [router]);

  return (
    <Layout product={product} theme={TENANCY}>
      <SignInComponent
        loggedout={router.query.reason === 'inactivity'}
        navigateToForgotPassword={() => {
          return navigateTo({ path: 'forgot-password' });
        }}
        navigateToResetPassword={() => {
          return navigateTo({ path: 'reset-password' });
        }}
        navigateToSetupMfa={() => {
          return navigateTo({ path: 'mfa' });
        }}
        navigateToSignup={() => {
          return navigateTo({ path: 'signup' });
        }}
        navigateToVerifyMfa={() => {
          navigateTo({ path: 'verifycode' });
        }}
        resetPasswordSuccess={resetPasswordSuccess}
        onRedirectToClient={(redirectURL: string, token?: string) => {
          return redirectToClient(redirectURL, token);
        }}
      />
    </Layout>
  );
}
